const PRESETS = {
  'top-50': {
    label: '🎯 Top 50 Targets',
    description: 'Most competitive races',
    filters: {
      competitivenessRange: [70, 100],
      marginRange: [-10, 10]
    }
  },
  'flippable': {
    label: '🔄 Flippable R Seats',
    description: 'Republican-held, close margins',
    filters: {
      marginRange: [-8, 0],
      competitivenessRange: [50, 100]
    }
  },
  'defensive': {
    label: '🛡️ Defensive Holds',
    description: 'Democratic-held, vulnerable',
    filters: {
      marginRange: [0, 8],
      competitivenessRange: [50, 100]
    }
  },
  'open-opportunities': {
    label: '🆕 Open Seats',
    description: 'No incumbent advantage',
    filters: {
      openSeatsOnly: true,
      competitivenessRange: [40, 100]
    }
  },
  'high-confidence': {
    label: '✓ High Confidence Only',
    description: 'Model certainty ≥80%',
    filters: {
      confidenceRange: [80, 100]
    }
  }
};

/**
 * Quick filter preset buttons
 *
 * @param {Object} props
 * @param {string} props.activePreset - Currently active preset ID
 * @param {Function} props.onSelect - Callback when preset is selected (presetId, filters)
 */
export function FilterPresets({ activePreset, onSelect }) {
  return (
    <div className="space-y-1.5 sm:space-y-2">
      <div className="text-xs sm:text-sm font-medium text-slate-300">Quick Presets</div>
      <div className="flex flex-wrap gap-1.5 sm:gap-2">
        {Object.entries(PRESETS).map(([id, preset]) => (
          <button
            key={id}
            onClick={() => onSelect(id, preset.filters)}
            className={`
              px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium transition-colors min-h-[36px] sm:min-h-[44px] active:scale-95
              ${activePreset === id
                ? 'bg-accent-blue text-white'
                : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
              }
            `}
            title={preset.description}
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  );
}
